module.exports = __webpack_public_path__ + "img/image-schedule.0a50bd25.jpg";